const protocol = /https?:\/\//;
const port = /(:\d{1,5})/;
const path = /\/.*/;

export const extractHostname = (origin: string): string => {
  return origin.replace(protocol, '').replace(port, '').replace(path, '');
};
